import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#3b5998',
  width = '100%',
  className = '',
  viewBox = '0 0 30 30',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2">
        <path
          fill={fill}
          d="M26.786,32H3.214A3.214,3.214,0,0,0,0,35.214V58.786A3.214,3.214,0,0,0,3.214,62h9.191V51.8H8.186V47h4.219V43.341c0-4.162,2.478-6.461,6.273-6.461A25.558,25.558,0,0,1,22.4,37.2v4.085H20.3a2.4,2.4,0,0,0-2.707,2.594V47H22.2l-.737,4.8H17.595V62h9.191A3.214,3.214,0,0,0,30,58.786V35.214A3.214,3.214,0,0,0,26.786,32Z"
          transform="translate(0 -32)"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
